import { render, staticRenderFns } from "./hs-image.vue?vue&type=template&id=49fa40c5&scoped=true"
import script from "./hs-image.ts?vue&type=script&lang=ts&external"
export * from "./hs-image.ts?vue&type=script&lang=ts&external"
import style0 from "./hs-image.scss?vue&type=style&index=0&id=49fa40c5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fa40c5",
  null
  
)

export default component.exports